import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children, testid }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid={testid} className="min-h-screen bg-[#06091a] text-white">
      <header className="sticky top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo" className="flex items-center gap-3 group">
            <span className="block w-9 h-9 rounded-xl overflow-hidden border border-amber-400/30 transition-transform duration-300 group-hover:rotate-6">
              <img src="/logo.png" alt="DUELO" className="w-full h-full object-cover" />
            </span>
            <span className="font-display font-extrabold tracking-widest text-base">DUELO</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-btn"
            className="flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-xs font-bold text-slate-300 transition-all duration-200 hover:border-amber-400/40 hover:text-amber-300"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Voltar
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
        <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tight leading-tight">
          {title}
        </h1>
        <p className="mono mt-3 text-[11px] uppercase tracking-[0.2em] text-slate-500">
          {updated}
        </p>
        <div className="mt-10 flex flex-col gap-8">{children}</div>
      </main>

      <footer className="border-t border-white/10 py-8 text-center">
        <p className="mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
          © 2026 DUELO · +18 · Jogo responsável
        </p>
      </footer>
    </div>
  );
}

export function Section({ n, title, children }) {
  return (
    <section>
      <h2 className="flex items-baseline gap-3 font-display font-bold text-lg sm:text-xl text-white mb-3">
        <span className="mono text-sm text-amber-300">{n}</span>
        {title}
      </h2>
      <div className="text-sm sm:text-base text-slate-400 leading-relaxed flex flex-col gap-3">
        {children}
      </div>
    </section>
  );
}
